
// import React, { useState, useEffect } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import {
//   fetchParkUsers,
//   updateParkUser,
// } from "../redux/actions/parkEmployeeActions";
// import {
//   fetchDistricts,
//   fetchMunicipalities,
// } from "../redux/actions/locationActions";
// import Papa from "papaparse";
// import theme from "../components/shared/theme";
// import {
//   dropdownStyle,
//   thStyle,
//   tdStyle,
//   paginationButtonStyle,
// } from "../components/shared/themeStyles";
// import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
// import EditEmployeeModal from "../pages/parkEmployee_management/EditEmployeeModal";
// import ChangeStatusDropdown from "../pages/parkEmployee_management/ChangeStatusDropdown";

// const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// const EmployeePark = () => {
//   const dispatch = useDispatch();
//   const { parkUsers, totalPages: apiTotalPages } = useSelector(
//     (state) => state.parkUsers
//   );
//   const { districts, municipalities } = useSelector(
//     (state) => state.location
//   );

//   const [currentPage, setCurrentPage] = useState(1);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedDistrict, setSelectedDistrict] = useState("");
//   const [selectedMunicipality, setSelectedMunicipality] = useState("");
//   const [projectType, setProjectType] = useState("");
//   const [isEditOpen, setIsEditOpen] = useState(false);
//   const [editUser, setEditUser] = useState(null);
//   const [sortField, setSortField] = useState("");
//   const [sortOrder, setSortOrder] = useState("asc");

//   const itemsPerPage = 10;

//   // Fetch districts & municipalities
//   useEffect(() => {
//     dispatch(fetchDistricts());
//     dispatch(fetchMunicipalities());
//   }, [dispatch]);

//   // Fetch users
//   useEffect(() => {
//     dispatch(
//       fetchParkUsers({
//         page: currentPage,
//         limit: itemsPerPage,
//         district: selectedDistrict,
//         municipality: selectedMunicipality,
//         search: searchTerm,
//         sortField,
//         sortOrder,
//         project_type: projectType,
//       })
//     );
//   }, [
//     dispatch,
//     currentPage,
//     selectedDistrict,
//     selectedMunicipality,
//     searchTerm,
//     sortField,
//     sortOrder,
//     projectType,
//   ]);

//   // Reset municipality when district changes
//   useEffect(() => {
//     setSelectedMunicipality("");
//   }, [selectedDistrict]);

//   const filteredMunicipalities = selectedDistrict
//     ? municipalities.filter(
//         (m) => m.district_id === Number(selectedDistrict)
//       )
//     : municipalities;

//   const toggleSort = (field) => {
//     if (sortField === field) {
//       setSortOrder(sortOrder === "asc" ? "desc" : "asc");
//     } else {
//       setSortField(field);
//       setSortOrder("asc");
//     }
//   };

//   // CSV Export
//   const handleDownloadCSV = async () => {
//     try {
//       const token = localStorage.getItem("token");

//       const params = new URLSearchParams();
//       params.append("page", 1);
//       params.append("limit", 10000);

//       if (selectedDistrict) params.append("district", selectedDistrict);
//       if (selectedMunicipality)
//         params.append("municipality", selectedMunicipality);
//       if (searchTerm) params.append("search", searchTerm);
//       if (sortField) params.append("sortField", sortField);
//       if (sortOrder) params.append("sortOrder", sortOrder);
//       if (projectType) params.append("project_type", projectType);

//       const response = await fetch(
//         `${BASE_URL}/v1/api/getAllParkUsers?${params.toString()}`,
//         {
//           headers: { Authorization: localStorage.getItem("token") },
//         }
//       );

//       const result = await response.json();
//       const allData = result.data || [];

//       const csvRows = [
//         [
//           "ID",
//           "District",
//           "Municipality",
//           "Name",
//           "Phone",
//           "Designation",
//           "DOB",
//           "DOJ",
//           "Status",
//           "Project Type",
//           "Project Code",
//         ],
//       ];

//       allData.forEach((u) => {
//         csvRows.push([
//           u.id,
//           u.district_name || "",
//           u.municipality_name || "",
//           u.name || "",
//           u.phone || "",
//           u.designation || "",
//           u.dob ? new Date(u.dob).toLocaleDateString("en-IN") : "",
//           u.doj ? new Date(u.doj).toLocaleDateString("en-IN") : "",
//           u.status || "",
//           u.project_type || "",
//           u.project_code || "",
//         ]);
//       });

//       const csv = Papa.unparse(csvRows);
//       const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
//       const url = URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url;
//       link.download = "ParkUsers_Report.csv";
//       link.click();
//     } catch (err) {
//       console.error("CSV export failed:", err);
//     }
//   };

//   const handleEditClick = (user) => {
//     setEditUser(user);
//     setIsEditOpen(true);
//   };

//   const handleFieldChange = (field, value) =>
//     setEditUser((prev) => ({ ...prev, [field]: value }));

//   const handleUpdateSubmit = async (e) => {
//     e.preventDefault();
//     await dispatch(updateParkUser(editUser.id, editUser));
//     setIsEditOpen(false);
//     dispatch(
//       fetchParkUsers({
//         page: currentPage,
//         limit: itemsPerPage,
//         district: selectedDistrict,
//         municipality: selectedMunicipality,
//         search: searchTerm,
//         sortField,
//         sortOrder,
//         project_type: projectType,
//       })
//     );
//   };

//   const handlePageChange = (page) => {
//     if (page >= 1 && page <= apiTotalPages) setCurrentPage(page);
//   };

//   return (
//     <div
//       style={{
//         padding: theme.spacing.lg,
//         backgroundColor: theme.colors.background,
//         minHeight: "100vh",
//       }}
//     >
//       <h1
//         style={{
//           fontSize: theme.font.size["3xl"],
//           fontWeight: theme.font.weight.bold,
//           marginBottom: theme.spacing.lg,
//         }}
//       >
//         Park Users Management
//       </h1>

//       {/* Filters */}
//       <div
//         style={{
//           display: "flex",
//           gap: theme.spacing.sm,
//           flexWrap: "wrap",
//           marginBottom: theme.spacing.lg,
//           backgroundColor: "#fff",
//           padding: theme.spacing.md,
//           borderRadius: theme.radius.xl,
//           boxShadow: theme.shadow.soft,
//         }}
//       >
//         <select
//           value={selectedDistrict}
//           onChange={(e) => setSelectedDistrict(e.target.value)}
//           style={dropdownStyle}
//         >
//           <option value="">All Districts</option>
//           {districts.map((d) => (
//             <option key={d.id} value={d.id}>
//               {d.name}
//             </option>
//           ))}
//         </select>

//         <select
//           value={selectedMunicipality}
//           onChange={(e) => setSelectedMunicipality(e.target.value)}
//           style={dropdownStyle}
//         >
//           <option value="">All Municipalities</option>
//           {filteredMunicipalities.map((m) => (
//             <option key={m.id} value={m.id}>
//               {m.name}
//             </option>
//           ))}
//         </select>

//         {/* Project Type Filter */}
//         <select
//           value={projectType}
//           onChange={(e) => setProjectType(e.target.value)}
//           style={dropdownStyle}
//         >
//           <option value="">All Project Types</option>
//           <option value="Park">Park</option>
//           <option value="Shelter">Shelter</option>
//           <option value="Stretch">Stretch</option>
//         </select>

//         <input
//           type="text"
//           placeholder="Search by name or phone"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//           style={{
//             ...dropdownStyle,
//             minWidth: "220px",
//           }}
//         />

//         <div style={{ display: "flex", gap: 8, marginLeft: "auto" }}>
//           <button
//             onClick={() => {
//               setSearchTerm("");
//               setSelectedDistrict("");
//               setSelectedMunicipality("");
//               setProjectType("");
//               setCurrentPage(1);
//             }}
//             style={{
//               backgroundColor: theme.colors.primary,
//               color: "#fff",
//               padding: theme.spacing.sm,
//               borderRadius: theme.radius.md,
//               border: "none",
//               cursor: "pointer",
//             }}
//           >
//             Reset
//           </button>

//           <button
//             onClick={handleDownloadCSV}
//             style={{
//               backgroundColor: theme.colors.secondary,
//               color: "#fff",
//               padding: theme.spacing.sm,
//               borderRadius: theme.radius.md,
//               border: "none",
//               cursor: "pointer",
//             }}
//           >
//             Export CSV
//           </button>
//         </div>
//       </div>

//       {/* Table */}
//       <div
//         style={{
//           backgroundColor: "#fff",
//           borderRadius: theme.radius.xl,
//           boxShadow: theme.shadow.soft,
//           overflowX: "auto",
//         }}
//       >
//         <table style={{ 
//           width: "100%", 
//           borderCollapse: "collapse",
//           minWidth: "1200px",
//           fontSize: theme.font.size.sm,
//         }}>
//           <thead style={{ backgroundColor: theme.colors.grayDark, color: "#fff" }}>
//             <tr>
//               <th style={thStyle} onClick={() => toggleSort("id")}>
//                 ID {sortField === "id" ? (sortOrder === "asc" ? " ↑" : " ↓") : ""}
//               </th>
//               <th style={thStyle} onClick={() => toggleSort("name")}>
//                 NAME {sortField === "name" ? (sortOrder === "asc" ? " ↑" : " ↓") : ""}
//               </th>
//               <th style={thStyle} onClick={() => toggleSort("phone")}>
//                 PHONE {sortField === "phone" ? (sortOrder === "asc" ? " ↑" : " ↓") : ""}
//               </th>
//               <th style={thStyle} onClick={() => toggleSort("designation")}>
//                 DESIGNATION {sortField === "designation" ? (sortOrder === "asc" ? " ↑" : " ↓") : ""}
//               </th>
//               <th style={thStyle} onClick={() => toggleSort("district_name")}>
//                 DISTRICT {sortField === "district_name" ? (sortOrder === "asc" ? " ↑" : " ↓") : ""}
//               </th>
//               <th style={thStyle} onClick={() => toggleSort("municipality_name")}>
//                 MUNICIPALITY {sortField === "municipality_name" ? (sortOrder === "asc" ? " ↑" : " ↓") : ""}
//               </th>
//               <th style={thStyle} onClick={() => toggleSort("project_type")}>
//                 PROJECT TYPE {sortField === "project_type" ? (sortOrder === "asc" ? " ↑" : " ↓") : ""}
//               </th>
//               <th style={thStyle} onClick={() => toggleSort("dob")}>
//                 DOB {sortField === "dob" ? (sortOrder === "asc" ? " ↑" : " ↓") : ""}
//               </th>
//               <th style={thStyle} onClick={() => toggleSort("doj")}>
//                 DOJ {sortField === "doj" ? (sortOrder === "asc" ? " ↑" : " ↓") : ""}
//               </th>
//               <th style={thStyle} onClick={() => toggleSort("project_code")}>
//                 PROJECT CODE {sortField === "project_code" ? (sortOrder === "asc" ? " ↑" : " ↓") : ""}
//               </th>
//               <th style={thStyle}>
//                 STATUS
//               </th>
//               <th style={thStyle}>
//                 ACTIONS
//               </th>
//             </tr>
//           </thead>
//           <tbody>
//             {parkUsers.length === 0 ? (
//               <tr>
//                 <td colSpan={12} style={{ textAlign: "center", padding: 20 }}>
//                   No Records Found
//                 </td>
//               </tr>
//             ) : (
//               parkUsers.map((u) => (
//                 <tr key={u.id}>
//                   <td style={tdStyle}>{u.id}</td>
//                   <td style={tdStyle}>{u.name}</td>
//                   <td style={tdStyle}>{u.phone}</td>
//                   <td style={tdStyle}>{u.designation}</td>
//                   <td style={tdStyle}>{u.district_name}</td>
//                   <td style={tdStyle}>{u.municipality_name}</td>
//                   <td style={tdStyle}>
//                     {u.project_type ? (
//                       <span
//                         style={{
//                           backgroundColor:
//                             u.project_type === "Park"
//                               ? "#4CAF50"
//                               : u.project_type === "Shelter"
//                               ? "#2196F3"
//                               : u.project_type === "Stretch"
//                               ? "#FF9800"
//                               : "#9E9E9E",
//                           color: "#fff",
//                           padding: "4px 8px",
//                           borderRadius: "12px",
//                           fontSize: "0.75rem",
//                           fontWeight: "bold",
//                           display: "inline-block",
//                         }}
//                       >
//                         {u.project_type}
//                       </span>
//                     ) : (
//                       "-"
//                     )}
//                   </td>
//                   <td style={tdStyle}>
//                     {u.dob ? new Date(u.dob).toLocaleDateString("en-IN") : "-"}
//                   </td>
//                   <td style={tdStyle}>
//                     {u.doj ? new Date(u.doj).toLocaleDateString("en-IN") : "-"}
//                   </td>
//                   <td style={tdStyle}>{u.project_code || "-"}</td>
//                   <td style={tdStyle}>
//                     <ChangeStatusDropdown
//                       userId={u.id}
//                       currentStatus={u.status}
//                     />
//                   </td>
//                   <td style={tdStyle}>
//                     <button
//                       onClick={() => handleEditClick(u)}
//                       style={{
//                         backgroundColor: theme.colors.primary,
//                         color: "#fff",
//                         padding: "6px 10px",
//                         borderRadius: theme.radius.sm,
//                         border: "none",
//                         cursor: "pointer",
//                       }}
//                     >
//                       Edit
//                     </button>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       <div
//         style={{
//           padding: theme.spacing.md,
//           backgroundColor: theme.colors.grayLight,
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           borderRadius: theme.radius.xl,
//           marginTop: theme.spacing.lg,
//         }}
//       >
//         <div>
//           <button
//             onClick={() => handlePageChange(currentPage - 1)}
//             disabled={currentPage === 1}
//             style={paginationButtonStyle}
//           >
//             <FiChevronLeft /> Previous
//           </button>
//         </div>

//         <span>
//           Page {currentPage} of {apiTotalPages}
//         </span>

//         <div>
//           <button
//             onClick={() => handlePageChange(currentPage + 1)}
//             disabled={currentPage === apiTotalPages}
//             style={paginationButtonStyle}
//           >
//             Next <FiChevronRight />
//           </button>
//         </div>
//       </div>

//       {isEditOpen && editUser && (
//         <EditEmployeeModal
//           employee={editUser}
//           onChange={handleFieldChange}
//           onCancel={() => setIsEditOpen(false)}
//           onSubmit={handleUpdateSubmit}
//         />
//       )}
//     </div>
//   );
// };

// export default EmployeePark;

import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchParkUsers,
  updateParkUser,
} from "../redux/actions/parkEmployeeActions";
import {
  fetchDistricts,
  fetchMunicipalities,
} from "../redux/actions/locationActions";
import Papa from "papaparse";
import theme from "../components/shared/theme";
import {
  dropdownStyle,
  thStyle,
  tdStyle,
  paginationButtonStyle,
} from "../components/shared/themeStyles";
import { FiChevronLeft, FiChevronRight, FiRefreshCw } from "react-icons/fi";
import EditEmployeeModal from "../pages/parkEmployee_management/EditEmployeeModal";
import ChangeStatusDropdown from "../pages/parkEmployee_management/ChangeStatusDropdown";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const EmployeePark = () => {
  const dispatch = useDispatch();
  const { parkUsers, totalPages: apiTotalPages, loading } = useSelector(
    (state) => state.parkUsers
  );
  const { districts, municipalities } = useSelector(
    (state) => state.location
  );

  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedMunicipality, setSelectedMunicipality] = useState("");
  const [projectType, setProjectType] = useState("");
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [isUpdating, setIsUpdating] = useState(false);

  const itemsPerPage = 10;

  // Fetch districts & municipalities
  useEffect(() => {
    dispatch(fetchDistricts());
    dispatch(fetchMunicipalities());
  }, [dispatch]);

  // Fetch users
  useEffect(() => {
    fetchData();
  }, [
    dispatch,
    currentPage,
    selectedDistrict,
    selectedMunicipality,
    searchTerm,
    sortField,
    sortOrder,
    projectType,
  ]);

  const fetchData = () => {
    dispatch(
      fetchParkUsers({
        page: currentPage,
        limit: itemsPerPage,
        district: selectedDistrict,
        municipality: selectedMunicipality,
        search: searchTerm,
        sortField,
        sortOrder,
        project_type: projectType,
      })
    );
  };

  // Reset municipality when district changes
  useEffect(() => {
    setSelectedMunicipality("");
  }, [selectedDistrict]);

  const filteredMunicipalities = selectedDistrict
    ? municipalities.filter(
        (m) => m.district_id === Number(selectedDistrict)
      )
    : municipalities;

  const toggleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  // CSV Export
  const handleDownloadCSV = async () => {
    try {
      const params = new URLSearchParams();
      params.append("page", 1);
      params.append("limit", 10000);

      if (selectedDistrict) params.append("district", selectedDistrict);
      if (selectedMunicipality)
        params.append("municipality", selectedMunicipality);
      if (searchTerm) params.append("search", searchTerm);
      if (sortField) params.append("sortField", sortField);
      if (sortOrder) params.append("sortOrder", sortOrder);
      if (projectType) params.append("project_type", projectType);

      const response = await fetch(
        `${BASE_URL}/v1/api/getAllParkUsers?${params.toString()}`,
        {
          headers: { Authorization: localStorage.getItem("token") },
        }
      );

      const result = await response.json();
      const allData = result.data || [];

      const csvRows = [
        [
          "ID",
          "District",
          "Municipality",
          "Name",
          "Phone",
          "Designation",
          "DOB",
          "DOJ",
          "Status",
          "Project Type",
          "Project Code",
        ],
      ];

      allData.forEach((u) => {
        csvRows.push([
          u.id,
          u.district_name || "",
          u.municipality_name || "",
          u.name || "",
          u.phone || "",
          u.designation || "",
          u.dob ? new Date(u.dob).toLocaleDateString("en-IN") : "",
          u.doj ? new Date(u.doj).toLocaleDateString("en-IN") : "",
          u.status || "",
          u.project_type || "",
          u.project_code || "",
        ]);
      });

      const csv = Papa.unparse(csvRows);
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "ParkUsers_Report.csv";
      link.click();
    } catch (err) {
      console.error("CSV export failed:", err);
      toast.error("Failed to export CSV");
    }
  };

  const handleEditClick = (user) => {
    setEditUser(user);
    setIsEditOpen(true);
  };

  const handleFieldChange = (field, value) =>
    setEditUser((prev) => ({ ...prev, [field]: value }));

  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    
    if (isUpdating) return;
    
    setIsUpdating(true);
    
    try {
      await dispatch(updateParkUser(editUser.id, editUser));
      setIsEditOpen(false);
      
      // Refresh data to ensure consistency
      fetchData();
      
      toast.success("User updated successfully!");
    } catch (error) {
      console.error("Update failed:", error);
      toast.error("Failed to update user");
    } finally {
      setIsUpdating(false);
    }
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= apiTotalPages) setCurrentPage(page);
  };

  const handleRefresh = () => {
    fetchData();
    toast.success("Data refreshed!");
  };

  const handleReset = () => {
    setSearchTerm("");
    setSelectedDistrict("");
    setSelectedMunicipality("");
    setProjectType("");
    setCurrentPage(1);
    setSortField("");
    setSortOrder("asc");
    fetchData();
  };

  return (
    <div
      style={{
        padding: theme.spacing.lg,
        backgroundColor: theme.colors.background,
        minHeight: "100vh",
      }}
    >
      <h1
        style={{
          fontSize: theme.font.size["3xl"],
          fontWeight: theme.font.weight.bold,
          marginBottom: theme.spacing.lg,
        }}
      >
        Park Users Management
      </h1>

      {/* Filters */}
      <div
        style={{
          display: "flex",
          gap: theme.spacing.sm,
          flexWrap: "wrap",
          marginBottom: theme.spacing.lg,
          backgroundColor: "#fff",
          padding: theme.spacing.md,
          borderRadius: theme.radius.xl,
          boxShadow: theme.shadow.soft,
        }}
      >
        <select
          value={selectedDistrict}
          onChange={(e) => setSelectedDistrict(e.target.value)}
          style={dropdownStyle}
        >
          <option value="">All Districts</option>
          {districts.map((d) => (
            <option key={d.id} value={d.id}>
              {d.name}
            </option>
          ))}
        </select>

        <select
          value={selectedMunicipality}
          onChange={(e) => setSelectedMunicipality(e.target.value)}
          style={dropdownStyle}
        >
          <option value="">All Municipalities</option>
          {filteredMunicipalities.map((m) => (
            <option key={m.id} value={m.id}>
              {m.name}
            </option>
          ))}
        </select>

        {/* Project Type Filter */}
        <select
          value={projectType}
          onChange={(e) => setProjectType(e.target.value)}
          style={dropdownStyle}
        >
          <option value="">All Project Types</option>
          <option value="Park">Park</option>
          <option value="Shelter">Shelter</option>
          <option value="Stretch">Stretch</option>
        </select>

        <input
          type="text"
          placeholder="Search by name or phone"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            ...dropdownStyle,
            minWidth: "220px",
          }}
        />

        <div style={{ display: "flex", gap: 8, marginLeft: "auto" }}>
          <button
            onClick={handleReset}
            style={{
              backgroundColor: theme.colors.primary,
              color: "#fff",
              padding: theme.spacing.sm,
              borderRadius: theme.radius.md,
              border: "none",
              cursor: "pointer",
            }}
          >
            Reset
          </button>

          <button
            onClick={handleRefresh}
            style={{
              backgroundColor: "#17a2b8",
              color: "#fff",
              padding: theme.spacing.sm,
              borderRadius: theme.radius.md,
              border: "none",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
            disabled={loading}
          >
            <FiRefreshCw className={loading ? "fa-spin" : ""} />
            {loading ? "Refreshing..." : "Refresh"}
          </button>

          <button
            onClick={handleDownloadCSV}
            style={{
              backgroundColor: theme.colors.secondary,
              color: "#fff",
              padding: theme.spacing.sm,
              borderRadius: theme.radius.md,
              border: "none",
              cursor: "pointer",
            }}
          >
            Export CSV
          </button>
        </div>
      </div>

      {/* Table */}
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: theme.radius.xl,
          boxShadow: theme.shadow.soft,
          overflowX: "auto",
          position: "relative",
        }}
      >
        {loading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "rgba(255,255,255,0.7)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1,
            }}
          >
            <div>Loading...</div>
          </div>
        )}
        
        <table style={{ 
          width: "100%", 
          borderCollapse: "collapse",
          minWidth: "1200px",
          fontSize: theme.font.size.sm,
        }}>
          <thead style={{ backgroundColor: theme.colors.grayDark, color: "#fff" }}>
            <tr>
              <th style={thStyle} onClick={() => toggleSort("id")}>
                ID {sortField === "id" ? (sortOrder === "asc" ? " ↑" : " ↓") : ""}
              </th>
              <th style={thStyle} onClick={() => toggleSort("name")}>
                NAME {sortField === "name" ? (sortOrder === "asc" ? " ↑" : " ↓") : ""}
              </th>
              <th style={thStyle} onClick={() => toggleSort("phone")}>
                PHONE {sortField === "phone" ? (sortOrder === "asc" ? " ↑" : " ↓") : ""}
              </th>
              <th style={thStyle} onClick={() => toggleSort("designation")}>
                DESIGNATION {sortField === "designation" ? (sortOrder === "asc" ? " ↑" : " ↓") : ""}
              </th>
              <th style={thStyle} onClick={() => toggleSort("district_name")}>
                DISTRICT {sortField === "district_name" ? (sortOrder === "asc" ? " ↑" : " ↓") : ""}
              </th>
              <th style={thStyle} onClick={() => toggleSort("municipality_name")}>
                MUNICIPALITY {sortField === "municipality_name" ? (sortOrder === "asc" ? " ↑" : " ↓") : ""}
              </th>
              <th style={thStyle} onClick={() => toggleSort("project_type")}>
                PROJECT TYPE {sortField === "project_type" ? (sortOrder === "asc" ? " ↑" : " ↓") : ""}
              </th>
              <th style={thStyle} onClick={() => toggleSort("dob")}>
                DOB {sortField === "dob" ? (sortOrder === "asc" ? " ↑" : " ↓") : ""}
              </th>
              <th style={thStyle} onClick={() => toggleSort("doj")}>
                DOJ {sortField === "doj" ? (sortOrder === "asc" ? " ↑" : " ↓") : ""}
              </th>
              <th style={thStyle} onClick={() => toggleSort("project_code")}>
                PROJECT CODE {sortField === "project_code" ? (sortOrder === "asc" ? " ↑" : " ↓") : ""}
              </th>
              <th style={thStyle}>
                STATUS
              </th>
              <th style={thStyle}>
                ACTIONS
              </th>
            </tr>
          </thead>
          <tbody>
            {parkUsers.length === 0 && !loading ? (
              <tr>
                <td colSpan={12} style={{ textAlign: "center", padding: 20 }}>
                  No Records Found
                </td>
              </tr>
            ) : (
              parkUsers.map((u) => (
                <tr key={u.id}>
                  <td style={tdStyle}>{u.id}</td>
                  <td style={tdStyle}>{u.name}</td>
                  <td style={tdStyle}>{u.phone}</td>
                  <td style={tdStyle}>{u.designation}</td>
                  <td style={tdStyle}>{u.district_name}</td>
                  <td style={tdStyle}>{u.municipality_name}</td>
                  <td style={tdStyle}>
                    {u.project_type ? (
                      <span
                        style={{
                          backgroundColor:
                            u.project_type === "Park"
                              ? "#4CAF50"
                              : u.project_type === "Shelter"
                              ? "#2196F3"
                              : u.project_type === "Stretch"
                              ? "#FF9800"
                              : "#9E9E9E",
                          color: "#fff",
                          padding: "4px 8px",
                          borderRadius: "12px",
                          fontSize: "0.75rem",
                          fontWeight: "bold",
                          display: "inline-block",
                        }}
                      >
                        {u.project_type}
                      </span>
                    ) : (
                      "-"
                    )}
                  </td>
                  <td style={tdStyle}>
                    {u.dob ? new Date(u.dob).toLocaleDateString("en-IN") : "-"}
                  </td>
                  <td style={tdStyle}>
                    {u.doj ? new Date(u.doj).toLocaleDateString("en-IN") : "-"}
                  </td>
                  <td style={tdStyle}>{u.project_code || "-"}</td>
                  <td style={tdStyle}>
                    <ChangeStatusDropdown
                      userId={u.id}
                      currentStatus={u.status}
                      onStatusChange={fetchData} // Refresh after status change
                    />
                  </td>
                  <td style={tdStyle}>
                    <button
                      onClick={() => handleEditClick(u)}
                      style={{
                        backgroundColor: theme.colors.primary,
                        color: "#fff",
                        padding: "6px 10px",
                        borderRadius: theme.radius.sm,
                        border: "none",
                        cursor: "pointer",
                      }}
                      disabled={isUpdating}
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div
        style={{
          padding: theme.spacing.md,
          backgroundColor: theme.colors.grayLight,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderRadius: theme.radius.xl,
          marginTop: theme.spacing.lg,
        }}
      >
        <div>
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1 || loading}
            style={paginationButtonStyle}
          >
            <FiChevronLeft /> Previous
          </button>
        </div>

        <span>
          Page {currentPage} of {apiTotalPages}
        </span>

        <div>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === apiTotalPages || loading}
            style={paginationButtonStyle}
          >
            Next <FiChevronRight />
          </button>
        </div>
      </div>

      {isEditOpen && editUser && (
        <EditEmployeeModal
          employee={editUser}
          onChange={handleFieldChange}
          onCancel={() => setIsEditOpen(false)}
          onSubmit={handleUpdateSubmit}
          isSubmitting={isUpdating}
        />
      )}
    </div>
  );
};

export default EmployeePark;